export default "__VITE_ASSET__CD_ot2L3__"